import {OperatorFunction, map} from "rxjs";

export function traverse<T,R>(project:(value:T, index:number)=>R):OperatorFunction<T,R|undefined|null>{
	return map((input:T, index:number):R|undefined|null=>{
		if(input===undefined)
			return undefined;
		if(input===null)
			return null;
		return project(input,index);
	});
}
